import * as React from 'react';
import { useAnalytics } from 'telia-front-react';

export const withAnalytics = (Component: React.ComponentClass<any>) => {
  return function WrappedComponent(props: any) {
    const { push } = useAnalytics();
    return <Component {...props} pushAnalytics={push} />;
  };
};
